import { type FunctionComponent } from 'react';
import { ReactComponent as ProductSVG } from '../../assets/icons/mevo/medicine/product.svg';
import IconPattern, { IconProps } from './_IconPattern';

const ProductIcon: FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={ProductSVG} variantPlaces={[]} {...props} />;
};

export default ProductIcon;
